<template>
  <v-container fluid>
    <h1 class="display-inline">Match Transactions</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <p>Use this tool to match bank transactions with invoices.</p>

    <v-row>
      <v-col cols="12">
        <CostTransactionMatching/>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import CostTransactionMatching from "@/components/costs/CostTransactionMatching.vue"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "CostsImportStaff",
  permissions: [...CostTransactionMatching.permissions],
  components: {
    ActiveApiCalls,
    CostTransactionMatching,
  },
  methods: {
    data() {
      return {}
    },
  }
}

</script>

<style scoped>

</style>